import Env from '../../base/env'
import {TweenMax} from 'gsap';

export default class Switcher
{
    constructor(view)
    {
        // DOM
        this.view = view
        this.$grid = this.view.querySelector('.jsGrid--view')
        this.$list = this.view.querySelector('.jsList--view')
        this.$btn = this.view.querySelector('.jsMode--trigger')
        // FLAGS
        this.FIRST_RENDERING = true
        // Fns
        this.events()
        this.setup()
    }

    events()
    {
        this.$btn.addEventListener('click',()=>{

            this.toggle()
        })
    }

    detect()
    {
        const mode = Env.workMode;

        if(mode === 'grid') {
            this.displayGrid()
        } else if(mode === 'list') {
            this.displayList()
        }
    }

    completeAll()
    {
        this.FIRST_RENDERING = false
    }

    displayGrid()
    {
        let timeline = new TimelineLite()
        this.$btn.classList.remove('mode--list')

        if(this.FIRST_RENDERING) {
            timeline.add(()=>{
                this.$list.style.display = 'none'
                this.$grid.style.display = 'block'
                this.$grid.style.opacity = 1
            })
            timeline.add([
                this.tweenGridIntroduction(),
                this.tweenGridCells()
            ])
            timeline.add(()=>{
                this.$grid.style.display = 'block'
                this.$list.style.display = 'none'
                this.completeAll()
            })
        } else {
            timeline.add(()=>{
                this.$list.style.display = 'block'
            })
            timeline.add([
                TweenLite.fromTo(this.$list , .7 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeIn })
            ])
            timeline.add(()=>{
                this.$grid.style.display = 'block'
                this.$list.style.display = 'none'
                this.$grid.style.opacity = 1
            })
            timeline.add([
                this.tweenGridIntroduction(),
                this.tweenGridCells()
            ])
            timeline.add(()=>{
                this.completeAll()
            })
        }

    }

    displayList()
    {
        let timeline = new TimelineLite()
        this.$btn.classList.add('mode--list')

        if(this.FIRST_RENDERING) {
            timeline.add(()=>{
                this.$list.style.display = 'block'
                this.$grid.style.display = 'none'
                this.$list.style.opacity = 1
            })
            timeline.add([
                this.tweenListItems()
            ])
            timeline.add(()=>{
                this.$grid.style.display = 'none'
                this.$list.style.display = 'block'
                this.completeAll()
            })
        } else {
            timeline.add(()=>{
                this.$grid.style.display = 'block'
            })
            timeline.add([
                TweenLite.fromTo(this.$grid , .7 , { opacity : 1 } , { opacity : 0 , ease : Cubic.easeIn })
            ])
            timeline.add(()=>{
                this.$grid.style.display = 'none'
                this.$list.style.display = 'block'
                this.$list.style.opacity = 1
            })
            timeline.add([
                this.tweenListItems()
            ])
            timeline.add(()=>{
                this.completeAll()
            })
        }
    }

    setup()
    {
        // this.detect()
    }

    toggle()
    {
        const mode = Env.workMode;

        if(mode === 'grid') {
            Env.workMode = 'list'
            this.displayList()
        } else if(mode === 'list') {
            Env.workMode = 'grid'
            this.displayGrid()
        }
    }

    tweenGridIntroduction()
    {
        return TweenLite.fromTo(this.$grid.querySelector('.workspace__introduction') , .6 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut })
    }

    tweenGridCells()
    {
        return TweenMax.staggerFromTo(this.$grid.querySelectorAll('.cell') , .6 , { y : 100 , opacity : 0 } , { opacity : 1 , y : 0 , ease : Cubic.easeOut , delay : .2 },.05)
    }

    tweenListItems()
    {
        return TweenMax.staggerFromTo(this.$list.querySelectorAll('.workspace-list__item') , .6 , { opacity : 0 , y : 35 } , { opacity : 1 , y : 0 , ease : Cubic.easeOut },.05)
    }

}